import styled from "@emotion/styled";

export const ContactGrid = styled.section(({ theme }) => ({
	display: "grid",
	gap: 8,
	gridTemplateColumns: "repeat(4, minmax(0, 1fr))",

	[theme.breakpoints.down("lg")]: {
		gridTemplateColumns: "repeat(2, minmax(0, 1fr))"
	},

	[theme.breakpoints.down("sm")]: {
		gridTemplateColumns: "1fr"
	}
}));

export const ContactCard = styled.article(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	border: `1px solid ${theme.palette.divider}`,
	height: "100%"
}));

export const ContactCardBody = styled.div({
	boxSizing: "border-box",
	display: "flex",
	flexDirection: "column",
	gap: 8,
	height: "100%",
	padding: 12
});

export const ContactHeader = styled.div(({ theme }) => ({
	alignItems: "center",
	display: "flex",
	gap: 8,

	"& > svg": {
		color: theme.project.colors.primaryColors.main,
		fontSize: 20
	}
}));

export const ContactName = styled.h2(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.main,
	fontWeight: 500,
	fontSize: 20,
	lineHeight: "160%",
	letterSpacing: "0.15px",
	margin: 0
}));

export const ContactTitle = styled.p(({ theme }) => ({
	...theme.project.typography.caption,
	color: theme.project.colors.fontColors.secondary,
	margin: 0,
	fontWeight: 400,
	fontSize: 14,
	lineHeight: "143%",
	letterSpacing: "0.17px"
}));

export const ContactRow = styled.div(({ theme }) => ({
	alignItems: "center",
	display: "grid",
	gap: 8,
	gridTemplateColumns: "20px minmax(0, 1fr)",

	"& > svg": {
		color: theme.project.colors.primaryColors.main,
		fontSize: 20
	}
}));

export const ContactLink = styled.a(({ theme }) => ({
	...theme.project.typography.caption,
	color: theme.project.colors.primaryColors.main,
	overflowWrap: "anywhere",
	textDecoration: "none",
	fontWeight: 400,
	fontSize: 12,
	lineHeight: "166%",
	letterSpacing: "0.17px",

	"&:hover": {
		textDecoration: "underline"
	}
}));

export const ContactText = styled.span(({ theme }) => ({
	...theme.project.typography.caption,
	color: theme.project.colors.fontColors.secondary,
	fontWeight: 400,
	fontSize: 12,
	lineHeight: "166%",
	letterSpacing: "0.17px"
}));

export const Hours = styled.div({
	minWidth: 0
});

export const Hour = styled.span(({ theme }) => ({
	...theme.project.typography.caption,
	color: theme.project.colors.fontColors.secondary,
	display: "block"
}));

export const ContactAction = styled.button(({ theme }) => ({
	...theme.project.typography.caption,
	alignItems: "center",
	backgroundColor: theme.project.colors.primaryColors.main,
	border: 0,
	color: theme.project.colors.fontColors.contrast,
	display: "flex",
	fontWeight: 500,
	justifyContent: "center",
	marginTop: "auto",
	minHeight: 32,
	padding: "0 16px",
	textAlign: "center",
	textDecoration: "none",
	textTransform: "uppercase",

	"&:not(:disabled):hover": {
		filter: "brightness(0.9)"
	},

	"&:focus-visible": {
		outline: `2px solid ${theme.project.colors.primaryColors.main}`,
		outlineOffset: 2
	}
}));
